<template>
  <div>
    <myHeader></myHeader>
    <div class="web-body">
      <div class="about">
        <my-banner :Mytype="'about'"></my-banner>
        <div class="row clearfix product-box">
          <div class="menu-ul">
            <router-link to="/about/company">公司</router-link>
            <!--<router-link to="/about/media">媒体</router-link>-->
            <router-link to="/cooperation">合作</router-link>
          </div>
        </div>
      </div>
    </div>
    <myFooter></myFooter>
  </div>
</template>

<script>
import banner from './banner';
import myFooter from './myFooter';
import myHeader from './myHeader';

export default {
  name: "about",
  components: {
    'my-banner': banner, myFooter, myHeader
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s ease;
}

.fade-enter, .fade-leave-active {
  opacity: 0
}
</style>



// WEBPACK FOOTER //
// src/components/about.vue